var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kyc-tab",class:{
  'active': _vm.active
},on:{"click":function($event){$event.preventDefault();return _vm.valueSelect.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.status === 'current' ? _vm.warning : _vm.status === 'pending' ? _vm.checkGray : _vm.status === 'done' ? _vm.checkGreen : null,"alt":"warning"}}),_c('div',{staticClass:"d-flex align-items-center"},[_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }